export default {
  // Hero
  'hero.badge': '透明流程',
  'hero.title': '使用指南',
  'hero.subtitle': '从产品选择到最终交付',
  'hero.desc':
    '从您分享想法的那一刻起，到成品安全送达为止，看看您的制造项目每一个阶段是如何被透明、专业地管理的。',
  'hero.imageAlt': '化妆品包装工厂生产线',

  // Step labels
  'step.label': '步骤',
  'step.titleSuffix': '化妆品包装流程',

  // Process overview
  'overview.label': '流程概览',
  'overview.title': '一图看懂整个流程',
  'overview.subtitle':
    '精心管理的十三个阶段，将您的想法从一次简单咨询一步步变成交付的产品。每个阶段环环相扣、质量可控，绝不靠运气。',
  'overview.track1.title': '咨询与规划',
  'overview.track1.desc': '从首次咨询到规格、报价、打样与确认——第1至7步。',
  'overview.track2.title': '生产与交付',
  'overview.track2.desc': '从批量生产到检验、包装、运输与售后——第8至13步。',

  // Step 1
  'steps.1.title': '产品搜索与咨询',
  'steps.1.desc':
    '通过浏览产品目录、分类搜索和以图搜图，找到合适的容器，并带着您的需求联系我们。',
  'steps.1.note':
    '一并发送产品图片和目标数量，能帮助我们更快、更准确地审核您的咨询。',
  'steps.1.item1': '产品搜索与比较',
  'steps.1.item2': '以图搜图查找相似产品',
  'steps.1.item3': '查看MOQ、材质、容量与库存状态',
  'steps.1.item4': '找不到合适产品时进行定制咨询',
  'steps.1.item5': '提供产品、数量、国家与预期时间',

  // Step 2
  'steps.2.title': '需求与规格审核',
  'steps.2.desc':
    '在报价前，我们会详细确认您的需求和产品规格，确保每一个细节都被准确理解。',
  'steps.2.note': '准确的规格审核决定了报价与样品的质量。',
  'steps.2.item1': '容器类型与容量',
  'steps.2.item2': '材质与颜色',
  'steps.2.item3': '泵头、瓶盖及其他配件配置',
  'steps.2.item4': '内容物与容器兼容性审核',
  'steps.2.item5': '印刷、涂层、贴标与后加工选择',
  'steps.2.item6': '目标数量与交期',
  'steps.2.item7': '运输国家与贸易条款',
  'steps.2.item8': '客户设计文件审核',

  // Step 3
  'steps.3.title': '报价与项目确认',
  'steps.3.desc': '基于已确认的规格，我们与您一起审核报价与生产条款。',
  'steps.3.note':
    '报价可能因最终规格、数量、后加工、汇率与运输条款而有所不同。',
  'steps.3.item1': '产品单价',
  'steps.3.item2': 'MOQ',
  'steps.3.item3': '样品与模具费用',
  'steps.3.item4': '印刷与后加工费用',
  'steps.3.item5': '包装与预估运费',
  'steps.3.item6': '预估生产周期',
  'steps.3.item7': '付款条款与报价有效期',
  'steps.3.item8': '国际贸易条款确认',

  // Step 4
  'steps.4.title': '样品制作与确认',
  'steps.4.desc': '在批量生产前，我们通过实物样品和原型来确认产品与设计。',
  'steps.4.note':
    '未经样品确认，我们不会进行重要的定制生产——这是我们的核心质量原则。',
  'steps.4.item1': '现有产品样品寄送',
  'steps.4.item2': '定制颜色与后加工样品制作',
  'steps.4.item3': '设计稿审核',
  'steps.4.item4': '模具或原型制作',
  'steps.4.item5': '客户样品评估',
  'steps.4.item6': '修改意见反馈',
  'steps.4.item7': '最终样品确认',

  // Step 5
  'steps.5.title': '订单与付款确认',
  'steps.5.desc': '最终规格与样品确认后，我们确认正式订单。',
  'steps.5.note': '只有在形式发票与合同条款确认后，生产才会开始。',
  'steps.5.item1': '最终报价单或形式发票确认',
  'steps.5.item2': '产品规格书确认',
  'steps.5.item3': '订单数量确认',
  'steps.5.item4': '交期安排确认',
  'steps.5.item5': '运输信息确认',
  'steps.5.item6': '合同与付款条款确认',
  'steps.5.item7': '生成生产订单号',

  // Step 6
  'steps.6.title': '产前准备',
  'steps.6.desc': '在批量生产开始前，我们再次检查所有生产条件。',
  'steps.6.note': '产前再次确认所有条件，以最大限度降低批量生产风险。',
  'steps.6.item1': '最终确认样品与生产规格对比',
  'steps.6.item2': '原材料与配件准备',
  'steps.6.item3': '模具与生产设备检查',
  'steps.6.item4': '颜色与印刷数据确认',
  'steps.6.item5': '制定生产计划与质检标准',
  'steps.6.item6': '产前内部审批',

  // Step 7
  'steps.7.title': '原材料与来料检验',
  'steps.7.desc': '我们在使用前检验进入生产的原材料与配件。',
  'steps.7.note': '不达标的材料绝不会投入生产。',
  'steps.7.item1': '原材料确认',
  'steps.7.item2': '泵头、瓶盖与配件检验',
  'steps.7.item3': '颜色与材质确认',
  'steps.7.item4': '供应配件规格检查',
  'steps.7.item5': '隔离不良或不达标材料',
  'steps.7.item6': '检验结果记录',

  // Step 8
  'steps.8.title': '批量生产',
  'steps.8.desc': '您的产品在我们的自动化大规模生产设施中生产。',
  'steps.8.note': '批次级追溯让每一笔订单的完整生产历史都可管理。',
  'steps.8.item1': '自动化生产线',
  'steps.8.item2': '注塑、吹塑、软管与玻璃容器生产',
  'steps.8.item3': '按工序进行生产管理',
  'steps.8.item4': '作业条件与生产数量控制',
  'steps.8.item5': '生产批次与追溯管理',
  'steps.8.item6': '熟练工人与质检人员的现场监督',

  // Step 9
  'steps.9.title': '制程质量控制',
  'steps.9.desc': '在线检验能在生产过程中尽早发现潜在问题。',
  'steps.9.note': '尽早发现问题，能降低整批产品的缺陷率。',
  'steps.9.item1': '外观与颜色检查',
  'steps.9.item2': '尺寸与重量检查',
  'steps.9.item3': '装配状态检验',
  'steps.9.item4': '泵头运行检验',
  'steps.9.item5': '渗漏与密封检查',
  'steps.9.item6': '印刷位置与印刷质量检查',
  'steps.9.item7': '隔离制程中的不良品',
  'steps.9.item8': '必要时调整生产条件',

  // Step 10
  'steps.10.title': '最终质量检验',
  'steps.10.desc': '成品在出货前进行最后一次检验。',
  'steps.10.note':
    '认证、检验标准与合格率仅在经过实际验证后才采用，具体数值在确认前以占位符显示。',
  'steps.10.item1': '最终外观检验',
  'steps.10.item2': '数量检验',
  'steps.10.item3': '尺寸与规格检验',
  'steps.10.item4': '功能与装配检验',
  'steps.10.item5': '渗漏与密封测试',
  'steps.10.item6': '印刷与后加工状态检查',
  'steps.10.item7': '包装状态检验',
  'steps.10.item8': '确认样品与成品对比',
  'steps.10.item9': '采用客户要求的检验标准',
  'steps.10.item10': '必要时提供检验报告',

  // Step 11
  'steps.11.title': '包装与出货准备',
  'steps.11.desc': '检验合格的产品被安全包装并准备出货。',
  'steps.11.note': '提前准备出口包装与运输单据，避免延误。',
  'steps.11.item1': '按产品进行保护性包装',
  'steps.11.item2': '内包装与出口纸箱包装',
  'steps.11.item3': '数量与标签检查',
  'steps.11.item4': '防损防污',
  'steps.11.item5': '托盘作业检查',
  'steps.11.item6': '制作装箱单',
  'steps.11.item7': '准备运输单据',
  'steps.11.item8': '出货前最终确认',

  // Step 12
  'steps.12.title': '国际运输与追踪',
  'steps.12.desc': '您的产品按约定条款运往您指定的国家。',
  'steps.12.note': '运输周期与费用可能因国家、运输方式、清关及当地情况而异。',
  'steps.12.item1': '快递、空运与海运',
  'steps.12.item2': '运输方式与预估时间确认',
  'steps.12.item3': '对接承运商或货代',
  'steps.12.item4': '准备出口报关单据',
  'steps.12.item5': '运输进度更新',
  'steps.12.item6': '提供追踪信息',
  'steps.12.item7': '目的地到货确认',

  // Step 13
  'steps.13.title': '交付与售后支持',
  'steps.13.desc': '交付后，我们完成订单并提供持续的售后支持。',
  'steps.13.note': '出现问题时，我们会根据照片和记录分析原因，并按约定政策响应。',
  'steps.13.item1': '交付完成确认',
  'steps.13.item2': '收货产品与数量检查',
  'steps.13.item3': '损坏或质量问题上报',
  'steps.13.item4': '相关照片与资料审核',
  'steps.13.item5': '根本原因分析',
  'steps.13.item6': '按约定政策响应',
  'steps.13.item7': '复购与后续项目支持',

  'steps.1.short': '搜索与咨询',
  'steps.2.short': '规格审核',
  'steps.3.short': '报价',
  'steps.4.short': '样品与确认',
  'steps.5.short': '订单与付款',
  'steps.6.short': '产前准备',
  'steps.7.short': '来料检验',
  'steps.8.short': '批量生产',
  'steps.9.short': '制程检验',
  'steps.10.short': '最终检验',
  'steps.11.short': '包装',
  'steps.12.short': '运输与追踪',
  'steps.13.short': '交付与支持',

  // Stock vs Custom
  'compare.label': '两条路径',
  'compare.title': '现货产品 vs 定制生产',
  'compare.subtitle': '现货产品与定制生产的流程和时间不同。请选择适合您的路径。',
  'compare.stock.title': '现货产品',
  'compare.stock.desc': '经过简单确认即可快速发货的现成品。',
  'compare.stock.step1': '库存确认',
  'compare.stock.step2': '报价',
  'compare.stock.step3': '付款',
  'compare.stock.step4': '出库',
  'compare.stock.step5': '交付',
  'compare.custom.title': '定制生产',
  'compare.custom.desc': '按您的确切规格制作的定制产品。',
  'compare.custom.step1': '规格沟通',
  'compare.custom.step2': '报价',
  'compare.custom.step3': '打样',
  'compare.custom.step4': '确认',
  'compare.custom.step5': '批量生产',
  'compare.custom.step6': '检验',
  'compare.custom.step7': '交付',

  // Order progress
  'progress.label': '订单进度可见',
  'progress.title': '在"我的"页面追踪您的订单',
  'progress.subtitle': '从咨询到交付，在您的个人仪表盘中跟进订单的每一个阶段。',
  'progress.status1': '咨询已受理',
  'progress.status2': '规格审核',
  'progress.status3': '已发送报价',
  'progress.status4': '打样进行中',
  'progress.status5': '样品确认',
  'progress.status6': '订单已确认',
  'progress.status7': '生产中',
  'progress.status8': '质量检验',
  'progress.status9': '待发货',
  'progress.status10': '已发货',
  'progress.status11': '已交付',
  'progress.note':
    '这是"我的"页面中订单状态如何显示的界面示例。实际状态更新将在订单数据接入后生效。',

  // Quality assurance
  'qa.label': '持续品质',
  'qa.title': '每个阶段的质量保证',
  'qa.subtitle': '质量并非只检查一次，而是在生产的每一个后续阶段持续管理。',
  'qa.stage1.title': '来料检验',
  'qa.stage1.desc': '原材料与配件在投入生产前进行检验。',
  'qa.stage2.title': '产前验证',
  'qa.stage2.desc': '生产开始前，对照确认样品核验生产条件。',
  'qa.stage3.title': '制程检验',
  'qa.stage3.desc': '在产线上检查产品，尽早发现问题。',
  'qa.stage4.title': '最终检验',
  'qa.stage4.desc': '出货前对成品进行最终检验。',
  'qa.stage5.title': '包装检验',
  'qa.stage5.desc': '核验包装的保护性与标签是否正确。',
  'qa.stage6.title': '出货验证',
  'qa.stage6.desc': '出货前确认单据与装货状态。',

  // Final CTA
  'cta.label': '准备开始',
  'cta.title': '启动您的包装项目',
  'cta.subtitle':
    '无论您需要现货容器还是完全定制的产品，我们的团队都将在每一步为您提供指导。',
  'cta.browse': '浏览产品',
  'cta.quote': '申请报价',
  'cta.custom': '开始您的定制项目',
  'cta.contact': '联系我们的团队',
};